import colors from "../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const GlobalSnackbarAlertStyle = makeStyles((theme) => ({
	snackbar: {
		bottom: "46px",
	},
	successMessage: {
		borderRadius: 10,
		marginBottom: 50,
		backgroundColor: colors.gray,
		border: `1px solid ${colors.green}`,
		color: colors.darkGreen,
		boxShadow: "unset",
		display: "flex",
		flexWrap: "wrap",
		maxWidth: "420px",
		minWidth: "420px",
		padding: 0,
		margin: 5,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "auto",
			minWidth: "auto",
			marginBottom: 65,
		},
	},
	errorMessage: {
		borderRadius: 10,
		marginBottom: 50,
		backgroundColor: colors.gray,
		border: `1px solid ${colors.orange}`,
		color: colors.darkRed,
		boxShadow: "unset",
		display: "flex",
		flexWrap: "wrap",
		maxWidth: "420px",
		minWidth: "420px",
		margin: 5,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "auto",
			minWidth: "auto",
			marginBottom: 65,
		},
	},
	successIcon: {
		color: colors.green,
	},
	errorIcon: {
		color: colors.orange,
	},
	justify: {
		display: "inline-flex",
	},
	errorList: {
		backgroundColor: colors.gray,
		boxShadow: "unset",
		maxWidth: "400px",
		minWidth: "400px",
		maxHeight: "170px",
		overflowY: "scroll",
		padding: 0,
		margin: 2,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "auto",
			minWidth: "auto",
		},
	},
	sucessList: {
		backgroundColor: colors.gray,
		boxShadow: "unset",
		maxWidth: "400px",
		minWidth: "400px",
		maxHeight: "170px",
		overflowY: "scroll",
		padding: 0,
		margin: 2,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "auto",
			minWidth: "auto",
		},
	},
	errorList_2: {
		marginTop: "2px",
		paddingLeft: "10px",
		color: colors.orange,
	},
	errorList_3: {
		paddingTop: "5px",
		paddingLeft: "40px",
	},
	successList_2: {
		marginTop: "2px",
		paddingLeft: "10px",
		color: colors.green,
	},
	successList_3: {
		paddingTop: "5px",
		paddingLeft: "40px",
	},
}));

export default GlobalSnackbarAlertStyle;
